import { useEffect, useState } from "react";
import api, { API } from "@/lib/api";
import { toast } from "sonner";
import { UploadSimple, Image as ImageIcon } from "@phosphor-icons/react";

export default function Settings() {
  const [logoId, setLogoId] = useState(null);
  useEffect(() => { api.get("/settings").then(r => setLogoId(r.data?.logo_file_id)); }, []);

  const upload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const fd = new FormData();
    fd.append("file", file);
    const { data } = await api.post("/settings/logo", fd);
    setLogoId(data.logo_file_id);
    toast.success("Logo updated");
  };

  return (
    <div data-testid="settings-page" className="space-y-6 max-w-3xl">
      <header>
        <div className="text-xs font-semibold uppercase tracking-[0.18em] text-slate-500">Settings</div>
        <h1 className="text-3xl md:text-4xl font-semibold tracking-tight">Brand & preferences</h1>
      </header>
      <div className="bg-white border border-slate-200/70 rounded-2xl p-6">
        <h2 className="text-xl font-semibold mb-1">AL-AXE brand logo</h2>
        <p className="text-sm text-slate-500 mb-5">Uploaded for use in the app header and exports.</p>
        <div className="flex items-center gap-6">
          <div className="w-40 h-40 rounded-2xl border border-slate-200 bg-slate-50 flex items-center justify-center overflow-hidden">
            {logoId ? <img data-testid="logo-preview" src={`${API}/files/${logoId}`} alt="logo" className="max-w-full max-h-full object-contain"/> : <ImageIcon size={40} className="text-slate-300"/>}
          </div>
          <label className="inline-flex items-center gap-2 al-gradient text-white px-5 py-3 rounded-full font-medium cursor-pointer active:scale-95">
            <UploadSimple size={16}/> Upload logo
            <input data-testid="logo-upload" type="file" accept="image/*" className="hidden" onChange={upload}/>
          </label>
        </div>
      </div>
    </div>
  );
}
